import { generateWords } from '../../../utils/generate'

export const CHECKBOX_LABEL = generateWords(10)
